<h2 mat-dialog-title>Add Image</h2>
<div mat-dialog-content class="image-upload__message">
  <div class="image-upload__blurb">To upload a file, select a jpeg, png, or tif file up to 10 MB in size, then press "Upload".</div>
  <!-- <input type="file" (change)="onFileChanged($event)"> -->
  <input
    style="display: none"
    type="file" accept="image/jpeg, image/png, image/tiff" (change)="onFileChanged($event)"
    #fileInput>
  <div class="image-upload__image-choice">
    <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" [disabled]="uploading" (click)="fileInput.click()">Select File</button>
    <span *ngIf="selectedFile && selectedFile.name" class="image-upload__selected-file">
      File: {{ selectedFile.name }}
    </span>
  </div>
  <div class="image-upload__image-choice">
    <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" [disabled]="uploadDisabled" (click)="onUpload()">Upload</button>
    <span *ngIf="statusPercent && statusPercent.length > 0" class="image-upload__upload-progress">
      Progress: {{ statusPercent }}% uploaded.
    </span>
  </div>
  <div *ngIf="completedFiles && completedFiles.length" class="image-upload__completed-files">
    <p>Files uploaded:</p>
    <div class="image-upload__completed-file" *ngFor="let file of completedFiles">
      {{ file }}
    </div>
  </div>

  <!-- <mat-form-field class="image-upload__image-choice">
    <mat-label>Select an image</mat-label>
    <mat-select [(value)]="selectedImage">
      <mat-option value="assets/splash/Alpine_airpark.jpg">Alpine_airpark.jpg</mat-option>
      <mat-option value="assets/images/sample2.jpg">sample2.jpg</mat-option>
      <mat-option value="assets/images/sample3.jpg">sample3.jpg</mat-option>
    </mat-select>
  </mat-form-field> -->
  <!-- <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" [disabled]="!selectedImage" (click)="onAddImage()">Add Image</button> -->
</div>
<div mat-dialog-actions>
  <!-- <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" (click)="onCancel()" cdkFocusInitial>Cancel</button> -->
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" [mat-dialog-close]="true" >Close</button>
</div>
